module.exports = __webpack_require__.p + "22cdf4d7ce256cdc090c45bbdb271048.jpg";